import React from "react";
import { Outlet } from "react-router-dom";

const RootLayout: React.FC = () => <Outlet />;

export default RootLayout;
